import { GENERAL_EVENTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);

@Component({ name: "TimeSelection" })
export default class TimeSelection extends Vue {
  @Prop({ default: "" }) private label!: string;
  @Prop({ default: "" }) private hint!: string;
  @Prop({ default: 0 }) private reset!: number;
  @Prop({ default: "" }) private newTime!: string;
  @Prop({ default: false }) private disableTimeComponent!: boolean;

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  menu = false;
  time = this.newTime;

  @Watch("reset")
  updateData() {
    this.time = this.newTime ?? "";
  }

  @Watch("time")
  timeUpdated() {
    this.$emit(GENERAL_EVENTS.UPDATE_FIELD, this.time);
  }
}
